import { useEffect } from 'react'
import type { Dispatch } from 'react'
import type { OrdersListFlowAction, OrdersListFlowState } from './OrdersListFlow.types'

type UseOrdersListFlowEffectsInput = {
  state: OrdersListFlowState
  totalPages: number
  dispatch: Dispatch<OrdersListFlowAction>
}

export const useOrdersListFlowEffects = ({
  state,
  totalPages,
  dispatch,
}: UseOrdersListFlowEffectsInput) => {
  useEffect(() => {
    dispatch({ type: 'SET_CURRENT_PAGE', value: 1 })
  }, [
    dispatch,
    state.searchValue,
    state.sortBy,
    state.dateFilter,
    state.customDateFrom,
    state.customDateTo,
    state.statusFilters,
    state.priceMin,
    state.priceMax,
    state.pageSize,
  ])

  useEffect(() => {
    if (state.currentPage > totalPages) {
      dispatch({ type: 'SET_CURRENT_PAGE', value: totalPages })
    }
  }, [dispatch, state.currentPage, totalPages])
}
